// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MoneyInput__wrapper___3Xxtq","icon-box":"MoneyInput__icon-box___TVPyD","input":"MoneyInput__input___2HE-W"};